// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/header_bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/make-life-easy-bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../public/images/awards-recog-bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../public/images/quote-sign.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../public/images/prev-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../public/images/next-icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------Mixins------------------*/
.ml-0 {
  margin-left: 0px !important;
}

.mr-0 {
  margin-right: 0px !important;
}

.mt-0 {
  margin-top: 0px !important;
}

.mb-0 {
  margin-bottom: 0px !important;
}

.mx-0 {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.my-0 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.ml-1 {
  margin-left: 4px !important;
}

.mr-1 {
  margin-right: 4px !important;
}

.mt-1 {
  margin-top: 4px !important;
}

.mb-1 {
  margin-bottom: 4px !important;
}

.mx-1 {
  margin-left: 4px !important;
  margin-right: 4px !important;
}

.my-1 {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}

.ml-2 {
  margin-left: 8px !important;
}

.mr-2 {
  margin-right: 8px !important;
}

.mt-2 {
  margin-top: 8px !important;
}

.mb-2 {
  margin-bottom: 8px !important;
}

.mx-2 {
  margin-left: 8px !important;
  margin-right: 8px !important;
}

.my-2 {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}

.ml-3 {
  margin-left: 12px !important;
}

.mr-3 {
  margin-right: 12px !important;
}

.mt-3 {
  margin-top: 12px !important;
}

.mb-3 {
  margin-bottom: 12px !important;
}

.mx-3 {
  margin-left: 12px !important;
  margin-right: 12px !important;
}

.my-3 {
  margin-top: 12px !important;
  margin-bottom: 12px !important;
}

.ml-4 {
  margin-left: 16px !important;
}

.mr-4 {
  margin-right: 16px !important;
}

.mt-4 {
  margin-top: 16px !important;
}

.mb-4 {
  margin-bottom: 16px !important;
}

.mx-4 {
  margin-left: 16px !important;
  margin-right: 16px !important;
}

.my-4 {
  margin-top: 16px !important;
  margin-bottom: 16px !important;
}

.ml-5 {
  margin-left: 20px !important;
}

.mr-5 {
  margin-right: 20px !important;
}

.mt-5 {
  margin-top: 20px !important;
}

.mb-5 {
  margin-bottom: 20px !important;
}

.mx-5 {
  margin-left: 20px !important;
  margin-right: 20px !important;
}

.my-5 {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}

.ml-6 {
  margin-left: 24px !important;
}

.mr-6 {
  margin-right: 24px !important;
}

.mt-6 {
  margin-top: 24px !important;
}

.mb-6 {
  margin-bottom: 24px !important;
}

.mx-6 {
  margin-left: 24px !important;
  margin-right: 24px !important;
}

.my-6 {
  margin-top: 24px !important;
  margin-bottom: 24px !important;
}

.ml-7 {
  margin-left: 28px !important;
}

.mr-7 {
  margin-right: 28px !important;
}

.mt-7 {
  margin-top: 28px !important;
}

.mb-7 {
  margin-bottom: 28px !important;
}

.mx-7 {
  margin-left: 28px !important;
  margin-right: 28px !important;
}

.my-7 {
  margin-top: 28px !important;
  margin-bottom: 28px !important;
}

.ml-8 {
  margin-left: 32px !important;
}

.mr-8 {
  margin-right: 32px !important;
}

.mt-8 {
  margin-top: 32px !important;
}

.mb-8 {
  margin-bottom: 32px !important;
}

.mx-8 {
  margin-left: 32px !important;
  margin-right: 32px !important;
}

.my-8 {
  margin-top: 32px !important;
  margin-bottom: 32px !important;
}

.ml-9 {
  margin-left: 36px !important;
}

.mr-9 {
  margin-right: 36px !important;
}

.mt-9 {
  margin-top: 36px !important;
}

.mb-9 {
  margin-bottom: 36px !important;
}

.mx-9 {
  margin-left: 36px !important;
  margin-right: 36px !important;
}

.my-9 {
  margin-top: 36px !important;
  margin-bottom: 36px !important;
}

.ml-10 {
  margin-left: 40px !important;
}

.mr-10 {
  margin-right: 40px !important;
}

.mt-10 {
  margin-top: 40px !important;
}

.mb-10 {
  margin-bottom: 40px !important;
}

.mx-10 {
  margin-left: 40px !important;
  margin-right: 40px !important;
}

.my-10 {
  margin-top: 40px !important;
  margin-bottom: 40px !important;
}

.ml-11 {
  margin-left: 44px !important;
}

.mr-11 {
  margin-right: 44px !important;
}

.mt-11 {
  margin-top: 44px !important;
}

.mb-11 {
  margin-bottom: 44px !important;
}

.mx-11 {
  margin-left: 44px !important;
  margin-right: 44px !important;
}

.my-11 {
  margin-top: 44px !important;
  margin-bottom: 44px !important;
}

.ml-12 {
  margin-left: 48px !important;
}

.mr-12 {
  margin-right: 48px !important;
}

.mt-12 {
  margin-top: 48px !important;
}

.mb-12 {
  margin-bottom: 48px !important;
}

.mx-12 {
  margin-left: 48px !important;
  margin-right: 48px !important;
}

.my-12 {
  margin-top: 48px !important;
  margin-bottom: 48px !important;
}

.ml-13 {
  margin-left: 52px !important;
}

.mr-13 {
  margin-right: 52px !important;
}

.mt-13 {
  margin-top: 52px !important;
}

.mb-13 {
  margin-bottom: 52px !important;
}

.mx-13 {
  margin-left: 52px !important;
  margin-right: 52px !important;
}

.my-13 {
  margin-top: 52px !important;
  margin-bottom: 52px !important;
}

.ml-14 {
  margin-left: 56px !important;
}

.mr-14 {
  margin-right: 56px !important;
}

.mt-14 {
  margin-top: 56px !important;
}

.mb-14 {
  margin-bottom: 56px !important;
}

.mx-14 {
  margin-left: 56px !important;
  margin-right: 56px !important;
}

.my-14 {
  margin-top: 56px !important;
  margin-bottom: 56px !important;
}

.ml-15 {
  margin-left: 60px !important;
}

.mr-15 {
  margin-right: 60px !important;
}

.mt-15 {
  margin-top: 60px !important;
}

.mb-15 {
  margin-bottom: 60px !important;
}

.mx-15 {
  margin-left: 60px !important;
  margin-right: 60px !important;
}

.my-15 {
  margin-top: 60px !important;
  margin-bottom: 60px !important;
}

.ml-16 {
  margin-left: 64px !important;
}

.mr-16 {
  margin-right: 64px !important;
}

.mt-16 {
  margin-top: 64px !important;
}

.mb-16 {
  margin-bottom: 64px !important;
}

.mx-16 {
  margin-left: 64px !important;
  margin-right: 64px !important;
}

.my-16 {
  margin-top: 64px !important;
  margin-bottom: 64px !important;
}

.ml-17 {
  margin-left: 68px !important;
}

.mr-17 {
  margin-right: 68px !important;
}

.mt-17 {
  margin-top: 68px !important;
}

.mb-17 {
  margin-bottom: 68px !important;
}

.mx-17 {
  margin-left: 68px !important;
  margin-right: 68px !important;
}

.my-17 {
  margin-top: 68px !important;
  margin-bottom: 68px !important;
}

.ml-18 {
  margin-left: 72px !important;
}

.mr-18 {
  margin-right: 72px !important;
}

.mt-18 {
  margin-top: 72px !important;
}

.mb-18 {
  margin-bottom: 72px !important;
}

.mx-18 {
  margin-left: 72px !important;
  margin-right: 72px !important;
}

.my-18 {
  margin-top: 72px !important;
  margin-bottom: 72px !important;
}

.ml-19 {
  margin-left: 76px !important;
}

.mr-19 {
  margin-right: 76px !important;
}

.mt-19 {
  margin-top: 76px !important;
}

.mb-19 {
  margin-bottom: 76px !important;
}

.mx-19 {
  margin-left: 76px !important;
  margin-right: 76px !important;
}

.my-19 {
  margin-top: 76px !important;
  margin-bottom: 76px !important;
}

.pl-0 {
  padding-left: 0px !important;
}

.pr-0 {
  padding-right: 0px !important;
}

.pt-0 {
  padding-top: 0px !important;
}

.pb-0 {
  padding-bottom: 0px !important;
}

.px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.pl-1 {
  padding-left: 4px !important;
}

.pr-1 {
  padding-right: 4px !important;
}

.pt-1 {
  padding-top: 4px !important;
}

.pb-1 {
  padding-bottom: 4px !important;
}

.px-1 {
  padding-left: 4px !important;
  padding-right: 4px !important;
}

.py-1 {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.pl-2 {
  padding-left: 8px !important;
}

.pr-2 {
  padding-right: 8px !important;
}

.pt-2 {
  padding-top: 8px !important;
}

.pb-2 {
  padding-bottom: 8px !important;
}

.px-2 {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.py-2 {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.pl-3 {
  padding-left: 12px !important;
}

.pr-3 {
  padding-right: 12px !important;
}

.pt-3 {
  padding-top: 12px !important;
}

.pb-3 {
  padding-bottom: 12px !important;
}

.px-3 {
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.py-3 {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}

.pl-4 {
  padding-left: 16px !important;
}

.pr-4 {
  padding-right: 16px !important;
}

.pt-4 {
  padding-top: 16px !important;
}

.pb-4 {
  padding-bottom: 16px !important;
}

.px-4 {
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.py-4 {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}

.pl-5 {
  padding-left: 20px !important;
}

.pr-5 {
  padding-right: 20px !important;
}

.pt-5 {
  padding-top: 20px !important;
}

.pb-5 {
  padding-bottom: 20px !important;
}

.px-5 {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.py-5 {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.pl-6 {
  padding-left: 24px !important;
}

.pr-6 {
  padding-right: 24px !important;
}

.pt-6 {
  padding-top: 24px !important;
}

.pb-6 {
  padding-bottom: 24px !important;
}

.px-6 {
  padding-left: 24px !important;
  padding-right: 24px !important;
}

.py-6 {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}

.pl-7 {
  padding-left: 28px !important;
}

.pr-7 {
  padding-right: 28px !important;
}

.pt-7 {
  padding-top: 28px !important;
}

.pb-7 {
  padding-bottom: 28px !important;
}

.px-7 {
  padding-left: 28px !important;
  padding-right: 28px !important;
}

.py-7 {
  padding-top: 28px !important;
  padding-bottom: 28px !important;
}

.pl-8 {
  padding-left: 32px !important;
}

.pr-8 {
  padding-right: 32px !important;
}

.pt-8 {
  padding-top: 32px !important;
}

.pb-8 {
  padding-bottom: 32px !important;
}

.px-8 {
  padding-left: 32px !important;
  padding-right: 32px !important;
}

.py-8 {
  padding-top: 32px !important;
  padding-bottom: 32px !important;
}

.pl-9 {
  padding-left: 36px !important;
}

.pr-9 {
  padding-right: 36px !important;
}

.pt-9 {
  padding-top: 36px !important;
}

.pb-9 {
  padding-bottom: 36px !important;
}

.px-9 {
  padding-left: 36px !important;
  padding-right: 36px !important;
}

.py-9 {
  padding-top: 36px !important;
  padding-bottom: 36px !important;
}

.pl-10 {
  padding-left: 40px !important;
}

.pr-10 {
  padding-right: 40px !important;
}

.pt-10 {
  padding-top: 40px !important;
}

.pb-10 {
  padding-bottom: 40px !important;
}

.px-10 {
  padding-left: 40px !important;
  padding-right: 40px !important;
}

.py-10 {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}

.pl-11 {
  padding-left: 44px !important;
}

.pr-11 {
  padding-right: 44px !important;
}

.pt-11 {
  padding-top: 44px !important;
}

.pb-11 {
  padding-bottom: 44px !important;
}

.px-11 {
  padding-left: 44px !important;
  padding-right: 44px !important;
}

.py-11 {
  padding-top: 44px !important;
  padding-bottom: 44px !important;
}

.pl-12 {
  padding-left: 48px !important;
}

.pr-12 {
  padding-right: 48px !important;
}

.pt-12 {
  padding-top: 48px !important;
}

.pb-12 {
  padding-bottom: 48px !important;
}

.px-12 {
  padding-left: 48px !important;
  padding-right: 48px !important;
}

.py-12 {
  padding-top: 48px !important;
  padding-bottom: 48px !important;
}

.pl-13 {
  padding-left: 52px !important;
}

.pr-13 {
  padding-right: 52px !important;
}

.pt-13 {
  padding-top: 52px !important;
}

.pb-13 {
  padding-bottom: 52px !important;
}

.px-13 {
  padding-left: 52px !important;
  padding-right: 52px !important;
}

.py-13 {
  padding-top: 52px !important;
  padding-bottom: 52px !important;
}

.pl-14 {
  padding-left: 56px !important;
}

.pr-14 {
  padding-right: 56px !important;
}

.pt-14 {
  padding-top: 56px !important;
}

.pb-14 {
  padding-bottom: 56px !important;
}

.px-14 {
  padding-left: 56px !important;
  padding-right: 56px !important;
}

.py-14 {
  padding-top: 56px !important;
  padding-bottom: 56px !important;
}

.pl-15 {
  padding-left: 60px !important;
}

.pr-15 {
  padding-right: 60px !important;
}

.pt-15 {
  padding-top: 60px !important;
}

.pb-15 {
  padding-bottom: 60px !important;
}

.px-15 {
  padding-left: 60px !important;
  padding-right: 60px !important;
}

.py-15 {
  padding-top: 60px !important;
  padding-bottom: 60px !important;
}

.pl-16 {
  padding-left: 64px !important;
}

.pr-16 {
  padding-right: 64px !important;
}

.pt-16 {
  padding-top: 64px !important;
}

.pb-16 {
  padding-bottom: 64px !important;
}

.px-16 {
  padding-left: 64px !important;
  padding-right: 64px !important;
}

.py-16 {
  padding-top: 64px !important;
  padding-bottom: 64px !important;
}

.pl-17 {
  padding-left: 68px !important;
}

.pr-17 {
  padding-right: 68px !important;
}

.pt-17 {
  padding-top: 68px !important;
}

.pb-17 {
  padding-bottom: 68px !important;
}

.px-17 {
  padding-left: 68px !important;
  padding-right: 68px !important;
}

.py-17 {
  padding-top: 68px !important;
  padding-bottom: 68px !important;
}

.pl-18 {
  padding-left: 72px !important;
}

.pr-18 {
  padding-right: 72px !important;
}

.pt-18 {
  padding-top: 72px !important;
}

.pb-18 {
  padding-bottom: 72px !important;
}

.px-18 {
  padding-left: 72px !important;
  padding-right: 72px !important;
}

.py-18 {
  padding-top: 72px !important;
  padding-bottom: 72px !important;
}

.pl-19 {
  padding-left: 76px !important;
}

.pr-19 {
  padding-right: 76px !important;
}

.pt-19 {
  padding-top: 76px !important;
}

.pb-19 {
  padding-bottom: 76px !important;
}

.px-19 {
  padding-left: 76px !important;
  padding-right: 76px !important;
}

.py-19 {
  padding-top: 76px !important;
  padding-bottom: 76px !important;
}

.homepage-layout {
  padding-top: 156px;
}
@media (max-width: 899px) {
  .homepage-layout {
    padding-top: 85px;
  }
  .homepage-layout h2 {
    font-size: 1.875rem;
    line-height: 45px;
  }
  .homepage-layout h4 {
    font-size: 1.25rem;
    line-height: 30px;
  }
  .homepage-layout .mb-margin1 {
    margin-bottom: 50px !important;
  }
  .homepage-layout .mb-margin2 {
    margin-bottom: 24px !important;
  }
}
.homepage-layout .header-section {
  padding-top: 30px;
  background: #E9F1FD;
}
.homepage-layout .header-section .hs-inner {
  min-height: 500px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center bottom/100%;
  padding-bottom: 60px;
}
.homepage-layout .header-section .hs-inner h6 {
  color: #1E2E5F;
  font-weight: 500;
  margin-bottom: 12px;
}
.homepage-layout .header-section .hs-inner .cli-productBox {
  border-radius: 12px;
  padding: 24px 0px;
  background: #ffffff;
}
@media (max-width: 599px) {
  .homepage-layout .header-section .hs-inner .cli-productBox {
    background: none;
  }
}
.homepage-layout .header-section .hs-inner .cli-productBox ul {
  display: flex;
  flex-wrap: wrap;
}
@media (max-width: 599px) {
  .homepage-layout .header-section .hs-inner .cli-productBox ul {
    gap: 12px;
  }
}
.homepage-layout .header-section .hs-inner .cli-productBox ul li {
  backdrop-filter: blur(10px);
  padding: 24px;
  flex: 1 1;
  min-width: 165px;
  text-align: center;
  position: relative;
  border-width: 0 1px 0 0;
  border-style: solid;
  border-image: linear-gradient(to bottom, rgba(196, 61, 73, 0.05) 0%, rgba(196, 61, 73, 0.5) 48.5%, rgba(196, 61, 73, 0.05)) 1 100%;
}
@media (max-width: 599px) {
  .homepage-layout .header-section .hs-inner .cli-productBox ul li {
    background: rgba(255, 255, 255, 0.4);
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(5px);
  }
}
.homepage-layout .header-section .hs-inner .cli-productBox ul li:last-child {
  border: none;
}
@media (max-width: 1200px) {
  .homepage-layout .header-section .hs-inner .cli-productBox ul li {
    border: none;
    padding: 24px 12px;
  }
}
@media (max-width: 599px) {
  .homepage-layout .header-section .hs-inner .cli-productBox ul li {
    min-width: 150px;
    padding: 12px;
  }
}
.homepage-layout .header-section .hs-inner .cli-productBox ul li a {
  display: inline-block;
}
.homepage-layout .header-section .hs-inner .cli-productBox ul li a img {
  width: 100px;
  height: 100px;
}
@media (max-width: 1200px) {
  .homepage-layout .header-section .hs-inner .cli-productBox ul li a img {
    width: 70px;
    height: 70px;
  }
}
@media (max-width: 599px) {
  .homepage-layout .header-section .hs-inner .cli-productBox ul li a img {
    border: none;
    border-radius: 8px;
  }
}
.homepage-layout .header-section .hs-inner .cli-productBox ul li a p {
  color: rgb(89, 89, 89);
  margin-top: 12px;
}
.homepage-layout .header-section .hs-inner .cli-productBox ul li a.disabled {
  cursor: not-allowed;
  opacity: 0.7;
}
.homepage-layout .vediobox .vedioWrapper {
  margin: auto;
  border-radius: 30px;
}
.homepage-layout .make-life-section {
  padding-bottom: 60px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center bottom/100%;
}
.homepage-layout .make-life-section ul {
  margin-bottom: 12px;
}
.homepage-layout .make-life-section ul li {
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 8px;
  color: rgb(89, 89, 89);
}
@media (max-width: 599px) {
  .homepage-layout .make-life-section ul li {
    text-align: justify;
  }
}
.homepage-layout .make-life-section ul li span {
  color: rgb(34, 34, 34);
  font-weight: 600;
}
.homepage-layout .make-life-section ul li:last-child {
  margin-bottom: 0;
}
@media (max-width: 599px) {
  .homepage-layout .make-life-section h2,
  .homepage-layout .make-life-section p {
    text-align: center;
  }
  .homepage-layout .make-life-section .make_life_esy_img {
    max-width: 350px;
    margin: auto;
  }
}
.homepage-layout .why-choose-section img {
  max-width: 385px;
  margin: 60px auto;
}
@media (max-width: 599px) {
  .homepage-layout .why-choose-section img {
    margin: 40px auto 24px;
    max-width: 300px;
  }
  .homepage-layout .why-choose-section h2,
  .homepage-layout .why-choose-section p,
  .homepage-layout .why-choose-section h4 {
    text-align: center;
  }
}
.homepage-layout .awards-section {
  background: #E9F1FD url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center bottom/100%;
  padding-top: 60px;
  padding-bottom: 60px;
}
@media (max-width: 899px) {
  .homepage-layout .awards-section {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .homepage-layout .awards-section h2 {
    margin-bottom: 24px !important;
  }
}
.homepage-layout .awards-section .awards-list {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
}
@media (max-width: 599px) {
  .homepage-layout .awards-section .awards-list {
    gap: 12px;
  }
}
.homepage-layout .awards-section .awards-list li {
  width: calc(25% - 18px);
  background: #ffffff;
  box-shadow: 0 12px 30px 0 rgba(30, 46, 95, 0.1);
  padding: 24px;
  border-radius: 15px;
  display: flex;
  min-width: 200px;
}
@media (max-width: 599px) {
  .homepage-layout .awards-section .awards-list li {
    min-width: 160px;
    padding: 24px 12px;
  }
}
.homepage-layout .awards-section .awards-list li img {
  margin: auto;
  object-fit: contain;
  max-height: 170px;
}
@media (max-width: 899px) {
  .homepage-layout .awards-section .awards-list li img {
    max-height: 100px;
  }
}
.homepage-layout .clients-section .clients_list {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
}
.homepage-layout .clients-section .clients_list li {
  border: 1px solid rgba(163, 183, 219, 0.3);
  padding: 12px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(16.6666666667% - 20px);
  height: 100px;
  min-width: 124px;
}
@media (max-width: 599px) {
  .homepage-layout .clients-section .clients_list li {
    flex: 1 1;
  }
}
.homepage-layout .clients-section .clients_list li img {
  object-fit: contain;
}
.homepage-layout .clients-section .clientBox {
  border: 1px solid rgba(163, 183, 219, 0.3);
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}
.homepage-layout .clients-section .clientBox img {
  object-fit: contain;
  max-height: 60px;
}
.homepage-layout .clients-section .logos {
  overflow: hidden;
  white-space: nowrap;
}
.homepage-layout .clients-section .logos .logos-outer {
  display: inline-block;
}
.homepage-layout .clients-section .logos .logos-outer .logos-slide {
  display: flex;
  animation: 30s slide infinite linear;
}
.homepage-layout .clients-section .logos .logos-outer .logos-slide .logobox {
  width: 180px;
  padding: 10px;
  border: 1px solid rgba(163, 183, 219, 0.3);
  margin: 12px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 599px) {
  .homepage-layout .clients-section .logos .logos-outer .logos-slide .logobox {
    width: 120px;
    margin: 6px;
  }
}
.homepage-layout .clients-section .logos .logos-outer .logos-slide .logobox img {
  max-height: 80px;
  width: 100%;
  object-fit: contain;
  border: none;
  outline: none;
}
@media (max-width: 599px) {
  .homepage-layout .clients-section .logos .logos-outer .logos-slide .logobox img {
    max-height: 60px;
  }
}
@keyframes slide {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}
.homepage-layout .sectors-section {
  background: #E9F1FD url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center bottom/100%;
  padding-top: 60px;
  padding-bottom: 60px;
}
@media (max-width: 599px) {
  .homepage-layout .sectors-section {
    padding-top: 30px;
    padding-bottom: 30px;
  }
}
.homepage-layout .sectors-section .sectors_list {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 60px;
}
@media (max-width: 899px) {
  .homepage-layout .sectors-section .sectors_list {
    gap: 30px;
  }
}
.homepage-layout .sectors-section .sectors_list li {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
@media (max-width: 899px) {
  .homepage-layout .sectors-section .sectors_list li {
    background: rgba(255, 255, 255, 0.4);
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(5px);
    padding: 12px 8px;
  }
}
.homepage-layout .sectors-section .sectors_list li img {
  height: 60px;
  width: 60px;
}
.homepage-layout .sectors-section .sectors_list li p {
  font-size: 18px;
  line-height: 27px;
  color: rgb(34, 34, 34);
  font-weight: 500;
  text-align: center;
}
@media (max-width: 899px) {
  .homepage-layout .sectors-section .sectors_list li p {
    font-size: 15px;
    line-height: 22px;
  }
  .homepage-layout .partners-section h2 {
    text-align: center;
  }
  .homepage-layout .partners-section p {
    text-align: justify;
  }
  .homepage-layout .partners-section .partners_main_img {
    margin: auto;
  }
}
@media (max-width: 599px) {
  .homepage-layout .partners-section .partners_main_img {
    max-width: 300px;
    margin: auto;
  }
}
.homepage-layout .partners-section ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}
.homepage-layout .partners-section ul li {
  padding: 12px;
  flex: 0 0 15%;
  display: flex;
  align-items: center;
}
.homepage-layout .partners-section .partnerBox {
  padding: 8px;
  height: 80px;
  display: flex;
  justify-content: center;
}
.homepage-layout .partners-section .partnerBox img {
  object-fit: contain;
  max-height: 60px;
}
.homepage-layout .testimonial-section {
  background: #E9F1FD url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center bottom/100%;
  padding-top: 60px;
  padding-bottom: 90px;
}
@media (max-width: 599px) {
  .homepage-layout .testimonial-section {
    padding-top: 30px;
    padding-bottom: 60px;
  }
}
.homepage-layout .testimonial-section .testmonial_box {
  margin: 20px 0;
}
.homepage-layout .testimonial-section .testmonial_box .reviewer_outer_profile_box {
  width: 180px;
  height: 100px;
  margin: auto;
  position: relative;
}
.homepage-layout .testimonial-section .testmonial_box .reviewer_outer_profile_box::before {
  content: "";
  position: absolute;
  top: calc(50% - 19px);
  left: 0;
  height: 38px;
  width: 180px;
  border: 1px solid #1E2E5F;
  border-radius: 100px;
  z-index: 0;
}
.homepage-layout .testimonial-section .testmonial_box .reviewer_profile_pic {
  box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  height: 100px;
  width: 100px;
  margin: auto;
  background: #ffffff;
  position: relative;
  z-index: 9;
}
.homepage-layout .testimonial-section .testmonial_box .rev_name {
  font-weight: 500;
  color: #000000;
  margin-bottom: 5px;
  margin-top: 20px;
}
.homepage-layout .testimonial-section .testmonial_box .review_box {
  max-width: 384px;
  margin: auto;
  position: relative;
  padding-top: 36px;
}
.homepage-layout .testimonial-section .testmonial_box .review_box::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat 0 0/33px;
  width: 33px;
  height: 33px;
}
.homepage-layout .testimonial-section .testmonial_box .review_box p {
  text-align: center;
}
@media (max-width: 599px) {
  .homepage-layout .testimonial-section .testmonial_box .review_box p {
    padding: 0px 8px 0px;
  }
}
.homepage-layout .testimonial-section .slick-slider .slick-active button {
  min-width: 32px;
  outline: 1px solid #1E2E5F;
  outline-offset: -1px;
  background: transparent;
}
.homepage-layout .testimonial-section .slick-slider .slick-dots li {
  margin: 0px 4px;
  width: 12px;
  height: 12px;
}
.homepage-layout .testimonial-section .slick-slider .slick-dots li.slick-active {
  min-width: 32px;
  width: 32px;
}
.homepage-layout .testimonial-section .slick-slider li button {
  background: rgba(36, 72, 140, 0.4);
  border-radius: 50px !important;
  border: none;
  width: 12px;
  height: 12px;
}
.homepage-layout .testimonial-section .slick-slider li button::before {
  display: none;
}
.homepage-layout .testimonial-section .slick-slider .slick-arrow {
  width: 72px;
  height: 50px;
  border: 1px solid #1E2E5F;
  border-radius: 12px;
  background-color: #DBE4F2;
  cursor: pointer;
  z-index: 9;
}
@media (max-width: 599px) {
  .homepage-layout .testimonial-section .slick-slider .slick-arrow {
    width: 40px;
    height: 40px;
    top: 45%;
  }
}
.homepage-layout .testimonial-section .slick-slider .slick-arrow.slick-prev {
  left: 0;
}
.homepage-layout .testimonial-section .slick-slider .slick-arrow.slick-prev:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat 0 0/24px;
  width: 24px;
  height: 18px;
  content: "";
  display: block;
  opacity: 1;
  position: absolute;
  top: calc(50% - 9px);
  left: calc(50% - 12px);
}
.homepage-layout .testimonial-section .slick-slider .slick-arrow.slick-next {
  right: 0;
}
.homepage-layout .testimonial-section .slick-slider .slick-arrow.slick-next:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat 0 0/24px;
  width: 24px;
  height: 18px;
  content: "";
  display: block;
  opacity: 1;
  position: absolute;
  top: calc(50% - 9px);
  left: calc(50% - 12px);
}
@media (max-width: 899px) {
  .homepage-layout .faq-section img {
    margin: auto;
    max-width: 260px;
  }
}`, "",{"version":3,"sources":["webpack://./src/SCSS/Mixins.scss","webpack://./src/Pages/Desktop/Homepage/HomePage.scss"],"names":[],"mappings":"AAWA,yCAAA;AAoDI;EACI,2BAAA;AC7DR;;ADgEI;EACI,4BAAA;AC7DR;;ADgEI;EACI,0BAAA;AC7DR;;ADgEI;EACI,6BAAA;AC7DR;;ADgEI;EACI,2BAAA;EACA,4BAAA;AC7DR;;ADgEI;EACI,0BAAA;EACA,6BAAA;AC7DR;;ADsCI;EACI,2BAAA;ACnCR;;ADsCI;EACI,4BAAA;ACnCR;;ADsCI;EACI,0BAAA;ACnCR;;ADsCI;EACI,6BAAA;ACnCR;;ADsCI;EACI,2BAAA;EACA,4BAAA;ACnCR;;ADsCI;EACI,0BAAA;EACA,6BAAA;ACnCR;;ADYI;EACI,2BAAA;ACTR;;ADYI;EACI,4BAAA;ACTR;;ADYI;EACI,0BAAA;ACTR;;ADYI;EACI,6BAAA;ACTR;;ADYI;EACI,2BAAA;EACA,4BAAA;ACTR;;ADYI;EACI,0BAAA;EACA,6BAAA;ACTR;;ADdI;EACI,4BAAA;ACiBR;;ADdI;EACI,6BAAA;ACiBR;;ADdI;EACI,2BAAA;ACiBR;;ADdI;EACI,8BAAA;ACiBR;;ADdI;EACI,4BAAA;EACA,6BAAA;ACiBR;;ADdI;EACI,2BAAA;EACA,8BAAA;ACiBR;;ADxCI;EACI,4BAAA;AC2CR;;ADxCI;EACI,6BAAA;AC2CR;;ADxCI;EACI,2BAAA;AC2CR;;ADxCI;EACI,8BAAA;AC2CR;;ADxCI;EACI,4BAAA;EACA,6BAAA;AC2CR;;ADxCI;EACI,2BAAA;EACA,8BAAA;AC2CR;;ADlEI;EACI,4BAAA;ACqER;;ADlEI;EACI,6BAAA;ACqER;;ADlEI;EACI,2BAAA;ACqER;;ADlEI;EACI,8BAAA;ACqER;;ADlEI;EACI,4BAAA;EACA,6BAAA;ACqER;;ADlEI;EACI,2BAAA;EACA,8BAAA;ACqER;;AD5FI;EACI,4BAAA;AC+FR;;AD5FI;EACI,6BAAA;AC+FR;;AD5FI;EACI,2BAAA;AC+FR;;AD5FI;EACI,8BAAA;AC+FR;;AD5FI;EACI,4BAAA;EACA,6BAAA;AC+FR;;AD5FI;EACI,2BAAA;EACA,8BAAA;AC+FR;;ADtHI;EACI,4BAAA;ACyHR;;ADtHI;EACI,6BAAA;ACyHR;;ADtHI;EACI,2BAAA;ACyHR;;ADtHI;EACI,8BAAA;ACyHR;;ADtHI;EACI,4BAAA;EACA,6BAAA;ACyHR;;ADtHI;EACI,2BAAA;EACA,8BAAA;ACyHR;;ADhJI;EACI,4BAAA;ACmJR;;ADhJI;EACI,6BAAA;ACmJR;;ADhJI;EACI,2BAAA;ACmJR;;ADhJI;EACI,8BAAA;ACmJR;;ADhJI;EACI,4BAAA;EACA,6BAAA;ACmJR;;ADhJI;EACI,2BAAA;EACA,8BAAA;ACmJR;;AD1KI;EACI,4BAAA;AC6KR;;AD1KI;EACI,6BAAA;AC6KR;;AD1KI;EACI,2BAAA;AC6KR;;AD1KI;EACI,8BAAA;AC6KR;;AD1KI;EACI,4BAAA;EACA,6BAAA;AC6KR;;AD1KI;EACI,2BAAA;EACA,8BAAA;AC6KR;;ADpMI;EACI,4BAAA;ACuMR;;ADpMI;EACI,6BAAA;ACuMR;;ADpMI;EACI,2BAAA;ACuMR;;ADpMI;EACI,8BAAA;ACuMR;;ADpMI;EACI,4BAAA;EACA,6BAAA;ACuMR;;ADpMI;EACI,2BAAA;EACA,8BAAA;ACuMR;;AD9NI;EACI,4BAAA;ACiOR;;AD9NI;EACI,6BAAA;ACiOR;;AD9NI;EACI,2BAAA;ACiOR;;AD9NI;EACI,8BAAA;ACiOR;;AD9NI;EACI,4BAAA;EACA,6BAAA;ACiOR;;AD9NI;EACI,2BAAA;EACA,8BAAA;ACiOR;;ADxPI;EACI,4BAAA;AC2PR;;ADxPI;EACI,6BAAA;AC2PR;;ADxPI;EACI,2BAAA;AC2PR;;ADxPI;EACI,8BAAA;AC2PR;;ADxPI;EACI,4BAAA;EACA,6BAAA;AC2PR;;ADxPI;EACI,2BAAA;EACA,8BAAA;AC2PR;;ADlRI;EACI,4BAAA;ACqRR;;ADlRI;EACI,6BAAA;ACqRR;;ADlRI;EACI,2BAAA;ACqRR;;ADlRI;EACI,8BAAA;ACqRR;;ADlRI;EACI,4BAAA;EACA,6BAAA;ACqRR;;ADlRI;EACI,2BAAA;EACA,8BAAA;ACqRR;;AD5SI;EACI,4BAAA;AC+SR;;AD5SI;EACI,6BAAA;AC+SR;;AD5SI;EACI,2BAAA;AC+SR;;AD5SI;EACI,8BAAA;AC+SR;;AD5SI;EACI,4BAAA;EACA,6BAAA;AC+SR;;AD5SI;EACI,2BAAA;EACA,8BAAA;AC+SR;;ADtUI;EACI,4BAAA;ACyUR;;ADtUI;EACI,6BAAA;ACyUR;;ADtUI;EACI,2BAAA;ACyUR;;ADtUI;EACI,8BAAA;ACyUR;;ADtUI;EACI,4BAAA;EACA,6BAAA;ACyUR;;ADtUI;EACI,2BAAA;EACA,8BAAA;ACyUR;;ADhWI;EACI,4BAAA;ACmWR;;ADhWI;EACI,6BAAA;ACmWR;;ADhWI;EACI,2BAAA;ACmWR;;ADhWI;EACI,8BAAA;ACmWR;;ADhWI;EACI,4BAAA;EACA,6BAAA;ACmWR;;ADhWI;EACI,2BAAA;EACA,8BAAA;ACmWR;;AD1XI;EACI,4BAAA;AC6XR;;AD1XI;EACI,6BAAA;AC6XR;;AD1XI;EACI,2BAAA;AC6XR;;AD1XI;EACI,8BAAA;AC6XR;;AD1XI;EACI,4BAAA;EACA,6BAAA;AC6XR;;AD1XI;EACI,2BAAA;EACA,8BAAA;AC6XR;;ADpZI;EACI,4BAAA;ACuZR;;ADpZI;EACI,6BAAA;ACuZR;;ADpZI;EACI,2BAAA;ACuZR;;ADpZI;EACI,8BAAA;ACuZR;;ADpZI;EACI,4BAAA;EACA,6BAAA;ACuZR;;ADpZI;EACI,2BAAA;EACA,8BAAA;ACuZR;;AD9aI;EACI,4BAAA;ACibR;;AD9aI;EACI,6BAAA;ACibR;;AD9aI;EACI,2BAAA;ACibR;;AD9aI;EACI,8BAAA;ACibR;;AD9aI;EACI,4BAAA;EACA,6BAAA;ACibR;;AD9aI;EACI,2BAAA;EACA,8BAAA;ACibR;;AD3aI;EACI,4BAAA;AC8aR;;AD3aI;EACI,6BAAA;AC8aR;;AD3aI;EACI,2BAAA;AC8aR;;AD3aI;EACI,8BAAA;AC8aR;;AD3aI;EACI,4BAAA;EACA,6BAAA;AC8aR;;AD3aI;EACI,2BAAA;EACA,8BAAA;AC8aR;;ADrcI;EACI,4BAAA;ACwcR;;ADrcI;EACI,6BAAA;ACwcR;;ADrcI;EACI,2BAAA;ACwcR;;ADrcI;EACI,8BAAA;ACwcR;;ADrcI;EACI,4BAAA;EACA,6BAAA;ACwcR;;ADrcI;EACI,2BAAA;EACA,8BAAA;ACwcR;;AD/dI;EACI,4BAAA;ACkeR;;AD/dI;EACI,6BAAA;ACkeR;;AD/dI;EACI,2BAAA;ACkeR;;AD/dI;EACI,8BAAA;ACkeR;;AD/dI;EACI,4BAAA;EACA,6BAAA;ACkeR;;AD/dI;EACI,2BAAA;EACA,8BAAA;ACkeR;;ADzfI;EACI,6BAAA;AC4fR;;ADzfI;EACI,8BAAA;AC4fR;;ADzfI;EACI,4BAAA;AC4fR;;ADzfI;EACI,+BAAA;AC4fR;;ADzfI;EACI,6BAAA;EACA,8BAAA;AC4fR;;ADzfI;EACI,4BAAA;EACA,+BAAA;AC4fR;;ADnhBI;EACI,6BAAA;ACshBR;;ADnhBI;EACI,8BAAA;ACshBR;;ADnhBI;EACI,4BAAA;ACshBR;;ADnhBI;EACI,+BAAA;ACshBR;;ADnhBI;EACI,6BAAA;EACA,8BAAA;ACshBR;;ADnhBI;EACI,4BAAA;EACA,+BAAA;ACshBR;;AD7iBI;EACI,6BAAA;ACgjBR;;AD7iBI;EACI,8BAAA;ACgjBR;;AD7iBI;EACI,4BAAA;ACgjBR;;AD7iBI;EACI,+BAAA;ACgjBR;;AD7iBI;EACI,6BAAA;EACA,8BAAA;ACgjBR;;AD7iBI;EACI,4BAAA;EACA,+BAAA;ACgjBR;;ADvkBI;EACI,6BAAA;AC0kBR;;ADvkBI;EACI,8BAAA;AC0kBR;;ADvkBI;EACI,4BAAA;AC0kBR;;ADvkBI;EACI,+BAAA;AC0kBR;;ADvkBI;EACI,6BAAA;EACA,8BAAA;AC0kBR;;ADvkBI;EACI,4BAAA;EACA,+BAAA;AC0kBR;;ADjmBI;EACI,6BAAA;AComBR;;ADjmBI;EACI,8BAAA;AComBR;;ADjmBI;EACI,4BAAA;AComBR;;ADjmBI;EACI,+BAAA;AComBR;;ADjmBI;EACI,6BAAA;EACA,8BAAA;AComBR;;ADjmBI;EACI,4BAAA;EACA,+BAAA;AComBR;;AD3nBI;EACI,6BAAA;AC8nBR;;AD3nBI;EACI,8BAAA;AC8nBR;;AD3nBI;EACI,4BAAA;AC8nBR;;AD3nBI;EACI,+BAAA;AC8nBR;;AD3nBI;EACI,6BAAA;EACA,8BAAA;AC8nBR;;AD3nBI;EACI,4BAAA;EACA,+BAAA;AC8nBR;;ADrpBI;EACI,6BAAA;ACwpBR;;ADrpBI;EACI,8BAAA;ACwpBR;;ADrpBI;EACI,4BAAA;ACwpBR;;ADrpBI;EACI,+BAAA;ACwpBR;;ADrpBI;EACI,6BAAA;EACA,8BAAA;ACwpBR;;ADrpBI;EACI,4BAAA;EACA,+BAAA;ACwpBR;;AD/qBI;EACI,6BAAA;ACkrBR;;AD/qBI;EACI,8BAAA;ACkrBR;;AD/qBI;EACI,4BAAA;ACkrBR;;AD/qBI;EACI,+BAAA;ACkrBR;;AD/qBI;EACI,6BAAA;EACA,8BAAA;ACkrBR;;AD/qBI;EACI,4BAAA;EACA,+BAAA;ACkrBR;;ADzsBI;EACI,6BAAA;AC4sBR;;ADzsBI;EACI,8BAAA;AC4sBR;;ADzsBI;EACI,4BAAA;AC4sBR;;ADzsBI;EACI,+BAAA;AC4sBR;;ADzsBI;EACI,6BAAA;EACA,8BAAA;AC4sBR;;ADzsBI;EACI,4BAAA;EACA,+BAAA;AC4sBR;;ADnuBI;EACI,6BAAA;ACsuBR;;ADnuBI;EACI,8BAAA;ACsuBR;;ADnuBI;EACI,4BAAA;ACsuBR;;ADnuBI;EACI,+BAAA;ACsuBR;;ADnuBI;EACI,6BAAA;EACA,8BAAA;ACsuBR;;ADnuBI;EACI,4BAAA;EACA,+BAAA;ACsuBR;;AD7vBI;EACI,6BAAA;ACgwBR;;AD7vBI;EACI,8BAAA;ACgwBR;;AD7vBI;EACI,4BAAA;ACgwBR;;AD7vBI;EACI,+BAAA;ACgwBR;;AD7vBI;EACI,6BAAA;EACA,8BAAA;ACgwBR;;AD7vBI;EACI,4BAAA;EACA,+BAAA;ACgwBR;;ADvxBI;EACI,6BAAA;AC0xBR;;ADvxBI;EACI,8BAAA;AC0xBR;;ADvxBI;EACI,4BAAA;AC0xBR;;ADvxBI;EACI,+BAAA;AC0xBR;;ADvxBI;EACI,6BAAA;EACA,8BAAA;AC0xBR;;ADvxBI;EACI,4BAAA;EACA,+BAAA;AC0xBR;;ADjzBI;EACI,6BAAA;ACozBR;;ADjzBI;EACI,8BAAA;ACozBR;;ADjzBI;EACI,4BAAA;ACozBR;;ADjzBI;EACI,+BAAA;ACozBR;;ADjzBI;EACI,6BAAA;EACA,8BAAA;ACozBR;;ADjzBI;EACI,4BAAA;EACA,+BAAA;ACozBR;;AD30BI;EACI,6BAAA;AC80BR;;AD30BI;EACI,8BAAA;AC80BR;;AD30BI;EACI,4BAAA;AC80BR;;AD30BI;EACI,+BAAA;AC80BR;;AD30BI;EACI,6BAAA;EACA,8BAAA;AC80BR;;AD30BI;EACI,4BAAA;EACA,+BAAA;AC80BR;;ADr2BI;EACI,6BAAA;ACw2BR;;ADr2BI;EACI,8BAAA;ACw2BR;;ADr2BI;EACI,4BAAA;ACw2BR;;ADr2BI;EACI,+BAAA;ACw2BR;;ADr2BI;EACI,6BAAA;EACA,8BAAA;ACw2BR;;ADr2BI;EACI,4BAAA;EACA,+BAAA;ACw2BR;;AD/3BI;EACI,6BAAA;ACk4BR;;AD/3BI;EACI,8BAAA;ACk4BR;;AD/3BI;EACI,4BAAA;ACk4BR;;AD/3BI;EACI,+BAAA;ACk4BR;;AD/3BI;EACI,6BAAA;EACA,8BAAA;ACk4BR;;AD/3BI;EACI,4BAAA;EACA,+BAAA;ACk4BR;;ADz5BI;EACI,6BAAA;AC45BR;;ADz5BI;EACI,8BAAA;AC45BR;;ADz5BI;EACI,4BAAA;AC45BR;;ADz5BI;EACI,+BAAA;AC45BR;;ADz5BI;EACI,6BAAA;EACA,8BAAA;AC45BR;;ADz5BI;EACI,4BAAA;EACA,+BAAA;AC45BR;;AA7gCA;EACI,kBAAA;AAghCJ;AA9gCI;EAHJ;IAIQ,iBAAA;EAihCN;EA9gCE;ID4BA,mBAAA;ICzBQ,iBAAA;EAihCV;EA7gCE;IDqBA,kBAAA;IClBQ,iBAAA;EAghCV;EA5gCE;IAEQ,8BAAA;EA+gCV;EA3gCE;IAEQ,8BAAA;EA8gCV;AArBF;AAr/BI;EACI,iBAAA;EACA,mBAAA;AA6gCR;AA3gCQ;EACI,iBAAA;EACA,gFAAA;EACA,oBAAA;AA6gCZ;AA3gCY;EACI,cD5CN;EC6CM,gBAAA;EACA,mBAAA;AA6gChB;AA1gCY;EACI,mBAAA;EACA,iBAAA;EACA,mBDjDR;AC6jCR;AA1gCgB;EALJ;IAMQ,gBAAA;EA6gClB;AACF;AA3gCgB;EACI,aAAA;EACA,eAAA;AA6gCpB;AA3gCoB;EAJJ;IAKQ,SAAA;EA8gCtB;AACF;AA5gCoB;EACI,2BAAA;EACA,aAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kIACI;AA6gC5B;AAxgCwB;EAfJ;IAgBQ,oCAAA;IACA,mBAAA;IACA,yCAAA;IACA,0BAAA;EA2gC1B;AACF;AAzgCwB;EACI,YAAA;AA2gC5B;AAxgCwB;EA1BJ;IA2BQ,YAAA;IACA,kBAAA;EA2gC1B;AACF;AAzgCwB;EA/BJ;IAgCQ,gBAAA;IACA,aAAA;EA4gC1B;AACF;AA1gCwB;EACI,qBAAA;AA4gC5B;AA1gC4B;EACI,YAAA;EACA,aAAA;AA4gChC;AA1gCgC;EAJJ;IAKQ,WAAA;IACA,YAAA;EA6gClC;AACF;AA3gCgC;EATJ;IAUQ,YAAA;IACA,kBAAA;EA8gClC;AACF;AA3gC4B;EACI,sBAAA;EACA,gBAAA;AA6gChC;AA1gC4B;EACI,mBAAA;EACA,YAAA;AA4gChC;AAlgCQ;EACI,YAAA;EACA,mBAAA;AAogCZ;AAhgCI;EACI,oBAAA;EACA,gFAAA;AAkgCR;AAhgCQ;EACI,mBAAA;AAkgCZ;AAhgCY;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAkgChB;AAhgCgB;EANJ;IAOQ,mBAAA;EAmgClB;AACF;AAjgCgB;EACI,sBAAA;EACA,gBAAA;AAmgCpB;AAhgCgB;EACI,gBAAA;AAkgCpB;AA3/BY;EAFJ;;IAGQ,kBAAA;EA+/Bd;EA3/BM;IAEQ,gBAAA;IACA,YAAA;EA8/Bd;AALF;AAn/BQ;EACI,gBAAA;EACA,iBAAA;AA2/BZ;AAz/BY;EAJJ;IAKQ,sBAAA;IACA,gBAAA;EA4/Bd;EAx/BM;;;IAIQ,kBAAA;EA2/Bd;AANF;AAh/BI;EAEI,wFAAA;EACA,iBAAA;EACA,oBAAA;AAw/BR;AAt/BQ;EANJ;IAOQ,iBAAA;IACA,oBAAA;EAy/BV;EAt/BM;IAEQ,8BAAA;EAy/Bd;AAJF;AAj/BQ;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;AAw/BZ;AAt/BY;EANJ;IAOQ,SAAA;EAy/Bd;AACF;AAv/BY;EACI,uBAAA;EACA,mBDxOR;ECyOQ,+CAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAy/BhB;AAv/BgB;EATJ;IAUQ,gBAAA;IACA,kBAAA;EA0/BlB;AACF;AAx/BgB;EACI,YAAA;EACA,mBAAA;EACA,iBAAA;AA0/BpB;AAx/BoB;EALJ;IAMQ,iBAAA;EA2/BtB;AACF;AAp/BQ;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;AAs/BZ;AAp/BY;EACI,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;EACA,aAAA;EACA,gBAAA;AAs/BhB;AAp/BgB;EAXJ;IAYQ,SAAA;EAu/BlB;AACF;AAr/BgB;EACI,mBAAA;AAu/BpB;AAl/BQ;EACI,0CAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAo/BZ;AAl/BY;EACI,mBAAA;EACA,gBAAA;AAo/BhB;AAh/BQ;EACI,gBAAA;EACA,mBAAA;AAk/BZ;AAh/BY;EACI,qBAAA;AAk/BhB;AAh/BgB;EAEI,aAAA;EACA,oCAAA;AAi/BpB;AA/+BoB;EACI,YAAA;EACA,aAAA;EACA,0CAAA;EACA,YAAA;ED1SpB,mBC2S2C;EACvB,aAAA;EACA,mBAAA;EACA,uBAAA;AAm/BxB;AAj/BwB;EAVJ;IAWQ,YAAA;IACA,WAAA;EAo/B1B;AACF;AAl/BwB;EACI,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AAo/B5B;AAl/B4B;EAPJ;IAQQ,gBAAA;EAq/B9B;AACF;AA9+BQ;EACI;IACI,wBAAA;EAg/Bd;EA7+BU;IACI,2BAAA;EA++Bd;AACF;AA3+BI;EACI,wFAAA;EACA,iBAAA;EACA,oBAAA;AA6+BR;AA3+BQ;EALJ;IAMQ,iBAAA;IACA,oBAAA;EA8+BV;AACF;AA5+BQ;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,SAAA;AA8+BZ;AA5+BY;EANJ;IAOQ,SAAA;EA++Bd;AACF;AA7+BY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AA++BhB;AA7+BgB;EANJ;IAOQ,oCAAA;IACA,mBAAA;IACA,yCAAA;IACA,0BAAA;IACA,iBAAA;EAg/BlB;AACF;AA9+BgB;EACI,YAAA;EACA,WAAA;AAg/BpB;AA7+BgB;EACI,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AA++BpB;AA7+BoB;EAPJ;IAQQ,eAAA;IACA,iBAAA;EAg/BtB;EAv+BM;IAEQ,kBAAA;EA0+Bd;EAt+BM;IAEQ,mBAAA;EAy+Bd;EAr+BM;IAEQ,YAAA;EAw+Bd;AAdF;AAv9BY;EALJ;IAMQ,gBAAA;IACA,YAAA;EAy+Bd;AACF;AAt+BQ;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;AAw+BZ;AAt+BY;EACI,aAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;AAw+BhB;AA59BQ;EACI,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AA89BZ;AA59BY;EACI,mBAAA;EACA,gBAAA;AA89BhB;AAz9BI;EACI,wFAAA;EACA,iBAAA;EACA,oBAAA;AA29BR;AAz9BQ;EALJ;IAMQ,iBAAA;IACA,oBAAA;EA49BV;AACF;AA19BQ;EACI,cAAA;AA49BZ;AA19BY;EACI,YAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;AA49BhB;AA19BgB;EACI,WAAA;ED/bhB,kBCgckC;ED/blC,qBC+bkD;ED5blD,OC4b2E;EAC3D,YAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;EACA,UAAA;AA89BpB;AA19BY;EACI,gDAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,mBDxfR;ECyfQ,kBAAA;EACA,UAAA;AA49BhB;AAz9BY;EACI,gBAAA;EACA,cDhgBR;ECigBQ,kBAAA;EACA,gBAAA;AA29BhB;AAx9BY;EACI,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA09BhB;AAx9BgB;EACI,WAAA;EDlehB,kBCmekC;EDlelC,MCkekD;ED/dlD,OC+d4D;EAC5C,sEAAA;EACA,WAAA;EACA,YAAA;AA49BpB;AAz9BgB;EACI,kBAAA;AA29BpB;AAz9BoB;EAHJ;IAIQ,oBAAA;EA49BtB;AACF;AAr9BY;EACI,eAAA;EACA,0BAAA;EACA,oBAAA;EACA,uBAAA;AAu9BhB;AAp9BY;EACI,eAAA;EACA,WAAA;EACA,YAAA;AAs9BhB;AAp9BgB;EACI,eAAA;EACA,WAAA;AAs9BpB;AAl9BY;EACI,kCAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAo9BhB;AAj9BgB;EACI,aAAA;AAm9BpB;AA/8BY;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,UAAA;AAi9BhB;AA/8BgB;EATJ;IAUQ,WAAA;IACA,YAAA;IACA,QAAA;EAk9BlB;AACF;AAh9BgB;EACI,OAAA;AAk9BpB;AAh9BoB;EACI,sEAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;AAk9BxB;AA98BgB;EACI,QAAA;AAg9BpB;AA98BoB;EACI,sEAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;AAg9BxB;AAv8BY;EADJ;IAEQ,YAAA;IACA,gBAAA;EA08Bd;AACF","sourcesContent":["// Color Variables\n$primary: #1E2E5F;\n$secondary: #BE2532;\n$black: #000000;\n$white: #ffffff;\n$grey: #808080;\n$red: #D9132E;\n$lightbg: #fbfbfb;\n$lightblue:#E9F1FD;\n\n\n/*--------------Mixins------------------*/\n@mixin box-shadow($shadow) {\n    -webkit-box-shadow: $shadow;\n    -moz-box-shadow: $shadow;\n    box-shadow: $shadow;\n}\n\n@mixin border-radius($radius: none) {\n    -webkit-border-radius: $radius;\n    -moz-border-radius: $radius;\n    border-radius: $radius;\n}\n\n@mixin appearance() {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n@function calculateRem($size) {\n    $remSize: $size / 16px;\n    @return #{$remSize}rem;\n}\n\n@mixin fontSize($size) {\n    //font-size: $size;\n    font-size: calculateRem($size);\n}\n\n@mixin position($position,\n    $top: null,\n    $right: null,\n    $bottom: null,\n    $left: null) {\n    position: $position;\n    top: $top;\n    right: $right;\n    bottom: $bottom;\n    left: $left;\n}\n\n@mixin abs-position ($top, $right, $bottom, $left) {\n    // @include abs-position(10px, 10px, auto, auto);\n    position: absolute;\n    top: $top;\n    right: $right;\n    bottom: $bottom;\n    left: $left;\n}\n\n// Margins\n@for $i from 0 to 20 {\n    .ml-#{$i} {\n        margin-left: 4px * $i !important;\n    }\n\n    .mr-#{$i} {\n        margin-right: 4px * $i !important;\n    }\n\n    .mt-#{$i} {\n        margin-top: 4px * $i !important;\n    }\n\n    .mb-#{$i} {\n        margin-bottom: 4px * $i !important;\n    }\n\n    .mx-#{$i} {\n        margin-left: 4px * $i !important;\n        margin-right: 4px * $i !important;\n    }\n\n    .my-#{$i} {\n        margin-top: 4px * $i !important;\n        margin-bottom: 4px * $i !important;\n    }\n}\n\n// Paddings\n@for $i from 0 to 20 {\n    .pl-#{$i} {\n        padding-left: 4px * $i !important;\n    }\n\n    .pr-#{$i} {\n        padding-right: 4px * $i !important;\n    }\n\n    .pt-#{$i} {\n        padding-top: 4px * $i !important;\n    }\n\n    .pb-#{$i} {\n        padding-bottom: 4px * $i !important;\n    }\n\n    .px-#{$i} {\n        padding-left: 4px * $i !important;\n        padding-right: 4px * $i !important;\n    }\n\n    .py-#{$i} {\n        padding-top: 4px * $i !important;\n        padding-bottom: 4px * $i !important;\n    }\n}","@import \"./../../../SCSS/Mixins.scss\";\n\n.homepage-layout {\n    padding-top: 156px;\n\n    @media(max-width:899px) {\n        padding-top: 85px;\n    }\n\n    h2 {\n        @media(max-width:899px) {\n            @include fontSize(30px);\n            line-height: 45px;\n        }\n    }\n\n    h4 {\n        @media(max-width:899px) {\n            @include fontSize(20px);\n            line-height: 30px;\n        }\n    }\n\n    .mb-margin1 {\n        @media(max-width:899px) {\n            margin-bottom: 50px !important;\n        }\n    }\n\n    .mb-margin2 {\n        @media(max-width:899px) {\n            margin-bottom: 24px !important;\n        }\n    }\n\n    .header-section {\n        padding-top: 30px;\n        background: #E9F1FD;\n\n        .hs-inner {\n            min-height: 500px;\n            background: url('./../../../../public//images/header_bg.svg')no-repeat center bottom/100%;\n            padding-bottom: 60px;\n\n            h6 {\n                color: $primary;\n                font-weight: 500;\n                margin-bottom: 12px;\n            }\n\n            .cli-productBox {\n                border-radius: 12px;\n                padding: 24px 0px;\n                background: $white;\n\n                @media(max-width:599px) {\n                    background: none;\n                }\n\n                ul {\n                    display: flex;\n                    flex-wrap: wrap;\n\n                    @media(max-width:599px) {\n                        gap: 12px;\n                    }\n\n                    li {\n                        backdrop-filter: blur(10px);\n                        padding: 24px;\n                        flex: 1;\n                        min-width: 165px;\n                        text-align: center;\n                        position: relative;\n                        border-width: 0 1px 0 0;\n                        border-style: solid;\n                        border-image:\n                            linear-gradient(to bottom,\n                                rgba(196, 61, 73, 0.05) 0%,\n                                rgba(196, 61, 73, 0.5) 48.5%,\n                                rgba(196, 61, 73, 0.05))1 100%;\n\n                        @media(max-width:599px) {\n                            background: rgba(255, 255, 255, 0.4);\n                            border-radius: 16px;\n                            box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n                            backdrop-filter: blur(5px);\n                        }\n\n                        &:last-child {\n                            border: none;\n                        }\n\n                        @media(max-width:1200px) {\n                            border: none;\n                            padding: 24px 12px;\n                        }\n\n                        @media(max-width:599px) {\n                            min-width: 150px;\n                            padding: 12px;\n                        }\n\n                        a {\n                            display: inline-block;\n\n                            img {\n                                width: 100px;\n                                height: 100px;\n\n                                @media(max-width:1200px) {\n                                    width: 70px;\n                                    height: 70px;\n                                }\n\n                                @media(max-width:599px) {\n                                    border: none;\n                                    border-radius: 8px;\n                                }\n                            }\n\n                            p {\n                                color: rgba(89, 89, 89, 1);\n                                margin-top: 12px;\n                            }\n\n                            &.disabled {\n                                cursor: not-allowed;\n                                opacity: 0.7;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .vediobox {\n        .vedioWrapper {\n            margin: auto;\n            border-radius: 30px;\n        }\n    }\n\n    .make-life-section {\n        padding-bottom: 60px;\n        background: url('./../../../../public/images/make-life-easy-bg.svg')no-repeat center bottom/100%;\n\n        ul {\n            margin-bottom: 12px;\n\n            li {\n                font-size: 14px;\n                line-height: 21px;\n                margin-bottom: 8px;\n                color: rgba(89, 89, 89, 1);\n\n                @media(max-width:599px) {\n                    text-align: justify;\n                }\n\n                span {\n                    color: rgba(34, 34, 34, 1);\n                    font-weight: 600;\n                }\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n        }\n\n        h2,\n        p {\n            @media(max-width:599px) {\n                text-align: center;\n            }\n        }\n\n        .make_life_esy_img {\n            @media(max-width:599px) {\n                max-width: 350px;\n                margin: auto;\n            }\n        }\n    }\n\n    .why-choose-section {\n        img {\n            max-width: 385px;\n            margin: 60px auto;\n\n            @media(max-width:599px) {\n                margin: 40px auto 24px;\n                max-width: 300px;\n            }\n        }\n\n        h2,\n        p,\n        h4 {\n            @media(max-width:599px) {\n                text-align: center;\n            }\n        }\n    }\n\n    .awards-section {\n        // background: #E9F1FD;\n        background: #E9F1FD url('./../../../../public/images/awards-recog-bg.svg')no-repeat center bottom/100%;\n        padding-top: 60px;\n        padding-bottom: 60px;\n\n        @media(max-width:899px) {\n            padding-top: 30px;\n            padding-bottom: 30px;\n        }\n\n        h2 {\n            @media(max-width:899px) {\n                margin-bottom: 24px !important;\n            }\n        }\n\n        .awards-list {\n            display: flex;\n            flex-wrap: wrap;\n            gap: 24px;\n            justify-content: center;\n\n            @media(max-width:599px) {\n                gap: 12px;\n            }\n\n            li {\n                width: calc(25% - 18px);\n                background: $white;\n                box-shadow: 0 12px 30px 0 rgba(30, 46, 95, 0.1);\n                padding: 24px;\n                border-radius: 15px;\n                display: flex;\n                min-width: 200px;\n\n                @media(max-width:599px) {\n                    min-width: 160px;\n                    padding: 24px 12px;\n                }\n\n                img {\n                    margin: auto;\n                    object-fit: contain;\n                    max-height: 170px;\n\n                    @media(max-width:899px) {\n                        max-height: 100px;\n                    }\n                }\n            }\n        }\n    }\n\n    .clients-section {\n        .clients_list {\n            display: flex;\n            flex-wrap: wrap;\n            gap: 24px;\n            justify-content: center;\n\n            li {\n                border: 1px solid rgba(163, 183, 219, 0.3);\n                padding: 12px;\n                border-radius: 10px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                width: calc((100% / 6) - 20px);\n                height: 100px;\n                min-width: 124px;\n\n                @media(max-width:599px) {\n                    flex: 1;\n                }\n\n                img {\n                    object-fit: contain;\n                }\n            }\n        }\n\n        .clientBox {\n            border: 1px solid rgba(163, 183, 219, 0.3);\n            padding: 8px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border-radius: 10px;\n\n            img {\n                object-fit: contain;\n                max-height: 60px;\n            }\n        }\n\n        .logos {\n            overflow: hidden;\n            white-space: nowrap;\n\n            .logos-outer {\n                display: inline-block;\n\n                .logos-slide {\n                    // white-space: nowrap;\n                    display: flex;\n                    animation: 30s slide infinite linear;\n\n                    .logobox {\n                        width: 180px;\n                        padding: 10px;\n                        border: 1px solid rgba(163, 183, 219, 0.3);\n                        margin: 12px;\n                        @include border-radius(10px);\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n\n                        @media(max-width:599px) {\n                            width: 120px;\n                            margin: 6px;\n                        }\n\n                        img {\n                            max-height: 80px;\n                            width: 100%;\n                            object-fit: contain;\n                            border: none;\n                            outline: none;\n\n                            @media(max-width:599px) {\n                                max-height: 60px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        @keyframes slide {\n            from {\n                transform: translateX(0);\n            }\n\n            to {\n                transform: translateX(-50%);\n            }\n        }\n    }\n\n    .sectors-section {\n        background: #E9F1FD url('./../../../../public/images/awards-recog-bg.svg')no-repeat center bottom/100%;\n        padding-top: 60px;\n        padding-bottom: 60px;\n\n        @media(max-width:599px) {\n            padding-top: 30px;\n            padding-bottom: 30px;\n        }\n\n        .sectors_list {\n            display: flex;\n            flex-direction: column;\n            flex-wrap: wrap;\n            gap: 60px;\n\n            @media(max-width:899px) {\n                gap: 30px;\n            }\n\n            li {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                gap: 12px;\n\n                @media(max-width:899px) {\n                    background: rgba(255, 255, 255, 0.4);\n                    border-radius: 16px;\n                    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n                    backdrop-filter: blur(5px);\n                    padding: 12px 8px;\n                }\n\n                img {\n                    height: 60px;\n                    width: 60px;\n                }\n\n                p {\n                    font-size: 18px;\n                    line-height: 27px;\n                    color: rgba(34, 34, 34, 1);\n                    font-weight: 500;\n                    text-align: center;\n\n                    @media(max-width:899px) {\n                        font-size: 15px;\n                        line-height: 22px;\n                    }\n                }\n            }\n        }\n    }\n\n    .partners-section {\n\n        h2 {\n            @media(max-width:899px) {\n                text-align: center;\n            }\n        }\n\n        p {\n            @media(max-width:899px) {\n                text-align: justify;\n            }\n        }\n\n        .partners_main_img {\n            @media(max-width:899px) {\n                margin: auto;\n            }\n\n            @media(max-width:599px) {\n                max-width: 300px;\n                margin: auto;\n            }\n        }\n\n        ul {\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: center;\n            gap: 12px;\n\n            li {\n                padding: 12px;\n                flex: 0 0 15%;\n                display: flex;\n                align-items: center;\n\n                img {\n                    // filter: grayscale(0.9);\n\n                    // &:hover {\n                    //     filter: grayscale(0);\n                    // }\n                }\n            }\n        }\n\n        .partnerBox {\n            padding: 8px;\n            height: 80px;\n            display: flex;\n            justify-content: center;\n\n            img {\n                object-fit: contain;\n                max-height: 60px;\n            }\n        }\n    }\n\n    .testimonial-section {\n        background: #E9F1FD url('./../../../../public/images/awards-recog-bg.svg')no-repeat center bottom/100%;\n        padding-top: 60px;\n        padding-bottom: 90px;\n\n        @media(max-width:599px) {\n            padding-top: 30px;\n            padding-bottom: 60px;\n        }\n\n        .testmonial_box {\n            margin: 20px 0;\n\n            .reviewer_outer_profile_box {\n                width: 180px;\n                height: 100px;\n                margin: auto;\n                position: relative;\n\n                &::before {\n                    content: '';\n                    @include position(absolute, $top: calc(50% - 19px), $left: 0);\n                    height: 38px;\n                    width: 180px;\n                    border: 1px solid $primary;\n                    border-radius: 100px;\n                    z-index: 0;\n                }\n            }\n\n            .reviewer_profile_pic {\n                box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.15);\n                border-radius: 50%;\n                height: 100px;\n                width: 100px;\n                margin: auto;\n                background: $white;\n                position: relative;\n                z-index: 9;\n            }\n\n            .rev_name {\n                font-weight: 500;\n                color: $black;\n                margin-bottom: 5px;\n                margin-top: 20px;\n            }\n\n            .review_box {\n                max-width: 384px;\n                margin: auto;\n                position: relative;\n                padding-top: 36px;\n\n                &::before {\n                    content: \"\";\n                    @include position(absolute, $top: 0, $left: 0);\n                    background: url(\"./../../../../public/images/quote-sign.svg\")no-repeat 0 0/33px;\n                    width: 33px;\n                    height: 33px;\n                }\n\n                p {\n                    text-align: center;\n\n                    @media(max-width:599px) {\n                        padding: 0px 8px 0px;\n                    }\n                }\n            }\n        }\n\n\n        .slick-slider {\n            .slick-active button {\n                min-width: 32px;\n                outline: 1px solid $primary;\n                outline-offset: -1px;\n                background: transparent;\n            }\n\n            .slick-dots li {\n                margin: 0px 4px;\n                width: 12px;\n                height: 12px;\n\n                &.slick-active {\n                    min-width: 32px;\n                    width: 32px;\n                }\n            }\n\n            li button {\n                background: rgba(36, 72, 140, 0.4);\n                border-radius: 50px !important;\n                border: none;\n                width: 12px;\n                height: 12px;\n\n\n                &::before {\n                    display: none;\n                }\n            }\n\n            .slick-arrow {\n                width: 72px;\n                height: 50px;\n                border: 1px solid $primary;\n                border-radius: 12px;\n                background-color: #DBE4F2;\n                cursor: pointer;\n                z-index: 9;\n\n                @media(max-width:599px) {\n                    width: 40px;\n                    height: 40px;\n                    top: 45%;\n                }\n\n                &.slick-prev {\n                    left: 0;\n\n                    &:before {\n                        background: url(\"./../../../../public/images/prev-icon.png\")no-repeat 0 0/24px;\n                        width: 24px;\n                        height: 18px;\n                        content: \"\";\n                        display: block;\n                        opacity: 1;\n                        position: absolute;\n                        top: calc(50% - 9px);\n                        left: calc(50% - 12px);\n                    }\n                }\n\n                &.slick-next {\n                    right: 0;\n\n                    &:before {\n                        background: url(\"./../../../../public/images/next-icon.png\")no-repeat 0 0/24px;\n                        width: 24px;\n                        height: 18px;\n                        content: \"\";\n                        display: block;\n                        opacity: 1;\n                        position: absolute;\n                        top: calc(50% - 9px);\n                        left: calc(50% - 12px);\n                    }\n                }\n            }\n        }\n    }\n\n    .faq-section {\n        img {\n            @media(max-width:899px) {\n                margin: auto;\n                max-width: 260px;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
